import { matchPath, useLocation } from "react-router-dom";

import { getOrganization } from "@/api/endpoints/organization";
import { ROUTES } from "@/routes_new";
import { useQuery } from "@tanstack/react-query";

export const useOrganization = () => {
  const { pathname } = useLocation();
  const match = matchPath<{ orgUuid: string }>(pathname, {
    path: ROUTES.APP_HOME_ORGID,
  });
  const orgUuid = match?.params?.orgUuid;

  return useQuery({
    queryKey: ["organization", orgUuid],
    enabled: !!orgUuid,
    queryFn: async () => {
      const response = await getOrganization();
      if (response?.ok) {
        const org = response.data.filter((org) => org.uuid === orgUuid);
        return {
          ok: response.ok,
          data: org[0],
        };
      }
      return response;
    },
    refetchOnWindowFocus: false,
  });
};
